
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_62453_149)","stroke":"#4A4A4A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6.6 1v.56M1 6.6h.56M8.84 2.12L9.4 1M2.12 8.84L1 9.4M11.244 9.564a.56.56 0 01.173-.91l3.248-1.247a.56.56 0 00-.05-1.04L3.412 2.71a.56.56 0 00-.7.7l3.657 11.207a.56.56 0 001.039.05l1.247-3.25a.56.56 0 01.91-.172l3.592 3.592a.56.56 0 00.792 0l.888-.886a.56.56 0 000-.792l-3.592-3.594z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_62453_149"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    